import { apiService } from "@/_services";
/**
 * Get clients for all companies
 * @param { object } companies initial company information
 */
export function getClients(companies) {
  let client = [];
  companies.forEach(function(comp) {
    comp["portfolios"].forEach(function(port) {
      client = client.concat(port["fk_id_client"]);
    });
  });
  let params = {
    method: "GET",
    endpoint: "clients",
    query_params: {
      format: "json",
      client: { id: client }
    }
  };
  return apiService.getAll(params);
}
